// extracted by mini-css-extract-plugin
export default {"modalMessageWrap":"ddsjYaoRuDRPPdERjdgV","title":"Ge67jfjWFqBO3pcnK52b","detail":"CML7GCNiJTy_v38mXxWM"};